import { signal } from '@angular/core';
import { debounce, FieldTree, min, required, SchemaPathTree } from '@angular/forms/signals';
import { UserDefinedFactorDto } from '../../../../core/mceapi.client.generated';
import { match, none, Option, some } from '../../../../shared/functions/functional';

export interface UserDefinedFactor {
  specified: boolean,
  description: string,
  value: number;
}

export function defaultUserDefinedFactor(): UserDefinedFactor {
  return { specified: false, description: 'default...', value: 1.0 };
}

export function buildUserDefinedFactorSchema(path: SchemaPathTree<UserDefinedFactor>) {

  required(path.description, { message: `Description is required` });
  debounce(path.description, 500);

  required(path.value, { message: `Factor value is required` });
  min(path.value, 0.0, { message: `Factor value must be above 0` });
  debounce(path.value, 500);
}

export function createUserDefinedFactor(dto: Option<UserDefinedFactorDto>) {
  let factor =
    match(
      () => defaultUserDefinedFactor(),
      (x: UserDefinedFactorDto): UserDefinedFactor => {
        if (x.description === undefined || x.value === undefined) {
          throw new Error('User-defined factor DTO is missing required values.');
        }

        return { specified: true, description: x.description, value: x.value };
      }
    )(dto);
  return signal<UserDefinedFactor>(factor);
}

export function createUserDefinedFactorDto(model: FieldTree<UserDefinedFactor>) {
  return signal<Option<UserDefinedFactorDto>>(
    model.specified().value()
      ? some({ description: model.description().value(), value: model.value().value() })
      : none
  );
}
